import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '99%',
    borderRadius: 24,
    background: '#FFFFFF',
    paddingBottom: 0,
    marginLeft: 5,
    marginTop: 3
  },
  header: {
    height: 130,
    flexShrink: 0,
    padding: 20,
    borderBottom: '1px solid #E9E9E9'
  },
  patientsList: {
    flexGrow: 1,
    overflowY: 'auto',
    scrollbarWidth: 'thin'
  },
  patientItem: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 90,
    alignItems: 'center',
    borderBottom: '1px solid #E9E9E9',
    padding: '0 20px',
    '&:last-child': {
      borderBottom: 'none'
    }
  }
}))

const NeedsAttentionSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid container className={classes.header} spacing={2} alignItems="center">
        <Grid item>
          <Skeleton variant="rect" width={90} height={80} />
        </Grid>
        <Grid item>
          <Skeleton variant="text" width={150} height={50} />
          <Skeleton variant="text" width={140} height={50} />
        </Grid>
        <Grid item>
          <Skeleton variant="text" width={80} height={50} />
          <Skeleton variant="text" width={120} height={50} />
        </Grid>
      </Grid>

      <Grid item className={classes.patientsList}>
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className={classes.patientItem}>
            <Skeleton variant="circle" width={50} height={50} />
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
          </div>
        ))}
      </Grid>
    </div>
  )
}

export default NeedsAttentionSkeleton
